<!--This Modal is using to show the success message-->
<template>
    <div>
        <modal :name="modal_name" class="final-modal success-vmodal modal-height" transition="nice-modal-fade" :delay="100"  :width="550" :height="320" :pivot-y="0.5" :adaptive="true" :scrollable="true" style="background:transparent">
            <div class="v-modal-content" style="border-radius: 15px;background:#fff !important;">
                <div class="pt-2 pl-0 pr-0 pb-1 m-4">
                    <div class="v-modal-body pt-0 pb-0" style="min-height: 450px;overflow-x: hidden;overflow-y: auto;">
                        <div class="d-form" style="overflow: initial !important;">
                            <div  class="text-center">
                                <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/parrot.svg" alt="" height="150px">
                                <div class="text-dark fw-600 fs-30 pt-2 pb-2">Success</div>
                                <div class="text-dark fs-16 pt-2 pb-2">{{message}}</div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-center">
                            <button type="button" class="btn ok-button btn-smm text-white ml-4" @click="okClicked" style="box-shadow: none;">
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
    </div>  
</template>
<script>
export default {
    props:['modal_name', 'message'], //getting the modal_name and message as a props from different components
    data(){
        return{
        }
    },
    methods:{
        //Hiding the success modal and calling the hideSuccess method from respective component
        okClicked() {
            setTimeout(() => {
                this.$modal.hide(this.modal_name);  /**@params = this.modal_name */
            }, 1000);
            this.$emit("hideSuccess"); 
        }
    }
}
</script>
<style scoped>
    .ok-button{
        background-color: #00448b !important;
        color: #fff !important;
    }
   
</style>


// WEBPACK FOOTER //
// src/components/SuccessMessage.vue